import { getLabel } from './mock'

const wpnonce = window?.dataWP?.config?.wpnonce;
const wpNonceParam = wpnonce ? `?_wpnonce=${wpnonce}` : '';

export const getPreflopData = async () => {
  return fetch(
    `${window.dataWP.config.endpoints.home_url}/wp-json/pokercoaching/v1/get_preflop_chart${wpNonceParam}`,
    {
      method: 'GET',
    },
  )
    .then((res) => {
      if (!res.ok) {
        throw Error('Response error')
      }
      return res.json()
    })
    .then((data) => data)
}

export const getChart = async ({ chartType, action, folder, idPath, type }) => {
  // if(process.env.NODE_ENV === 'development') {
  //   return import('../mock/data').then((module) => {
  //     return module.mockData(type);
  //   });
  // }

  const formData = new FormData()

  if (action === 'icm_chart_get') {
    formData.append('id_path', idPath)
    formData.append('root_folder', folder)

    let query = ''
    if (idPath) {
      const pathArray = idPath.split('/')
      query = pathArray.reduce((acc, curr, idx) => {
        let slash = idx !== pathArray.length - 1 ? '/' : ''
        const label = getLabel(curr)
        return `${acc}${label}${slash}`
      }, '')
    }

    formData.append('query', query)
  } else {
    if (folder) {
      formData.append('folder', folder)
    }
  }
  formData.append('chart_type', type)

  formData.append('action', action)
  formData.append('db', chartType)

  return fetch(
    `${window.dataWP.config.endpoints.home_url}/wp-json/pokercoaching/v1/get_charts${wpNonceParam}`,
    {
      method: 'POST',
      body: formData,
    },
  )
    .then((res) => {
      if (!res.ok) {
        throw Error('Response error')
      }
      return res.json()
    })
    .then((data) => data)
}
